// Charge la base commune
import './common.js'

// Contact Form
async function getCForm ($f) {
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // css complémentaires à un article en détail
  const $p = $('.service-content')
  if ($p.length) {
    $p.waypoint(function () {
      import(/* webpackChunkName: "serviceContent", webpackPrefetch: true */ './scss/components/serviceContent.scss')
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  if ($('.go').length) {
    const target = $('.go')
    $('html').animate({ scrollTop: ($(target).offset().top - $('#header').height()) - 20 }, { duration: 200, easing: 'linear' }, function () {
      $('html').animate({ scrollTop: ($(target).offset().top - $('#header').height()) - 20 }, { duration: 200, easing: 'linear' })
    })
  }

  // formulaire de contact
  const $cf = $('form[name="cForm"]')
  $cf.waypoint(function () {
    $cf.load()
    getCForm($cf)
    this.destroy()
  }, {
    offset: '100%'
  })
})
